import React from 'react';
import { Target, Zap, TrendingUp } from 'lucide-react';

const Mission = () => {
  return (
    <section id="mission" className="mission-section">
      <div className="section-container">
        <h2 className="section-title">Unser Ziel</h2>
        
        <div className="mission-content">
          <div className="mission-statement">
            <p className="mission-text-large">
              Wir glauben, dass <strong>Zeit die wertvollste Ressource</strong> eines Unternehmens ist.
            </p>
            
            <p className="mission-text">
              Unser Ziel ist es, unnötige Wiederholungsarbeiten zu eliminieren und Dokumentenprozesse 
              intelligent zu automatisieren – damit Menschen <strong>strategisch statt administrativ</strong> arbeiten können.
            </p>
          </div>

          <div className="mission-values">
            <div className="value-card">
              <div className="value-icon">
                <Target size={32} />
              </div>
              <h3 className="value-title">Präzision</h3>
              <p className="value-description">
                Schweizer Qualität in jedem automatisierten Prozess
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Zap size={32} />
              </div>
              <h3 className="value-title">Effizienz</h3>
              <p className="value-description">
                Maximale Zeitersparnis durch intelligente Automation
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <TrendingUp size={32} />
              </div>
              <h3 className="value-title">Skalierbarkeit</h3>
              <p className="value-description">
                Wachstum ohne proportionale Ressourcen-Erhöhung
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
